// Sentry chargé à la demande (import dynamique) : ~77 Ko sortent du bundle
// initial. L'init se fait APRÈS le premier rendu ; les erreurs survenues avant
// sont mises en file (bornée) puis capturées dès que Sentry est prêt → aucune
// perte de signalement.
let SentryMod = null;
let loadPromise = null;
let inited = false;
let pending = [];

function load() {
  if (!loadPromise) {
    loadPromise = import("@sentry/react")
      .then((m) => (m && m.default ? m.default : m))
      .catch(() => null);
  }
  return loadPromise;
}

export function initSentry() {
  const dsn =
    process.env.REACT_APP_SENTRY_DSN ||
    "https://95760d196c801f74bd85155e38e8d595@o4512017179475968.ingest.de.sentry.io/4512017209426000";
  load().then((S) => {
    if (!S || inited) return;
    try {
      S.init({
        dsn,
        environment: process.env.NODE_ENV || "development",
        release: process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_VERSION || undefined,
        tracesSampleRate: 0.1,
        ignoreErrors: ["ResizeObserver loop", "Non-Error promise rejection captured"],
        allowUrls: [window.location.origin],
      });
      SentryMod = S;
      inited = true;
      const q = pending;
      pending = [];
      for (const [e, c] of q) {
        try {
          S.captureException(e, c);
        } catch (_) {
          /* ignore */
        }
      }
    } catch (_) {
      /* ignore */
    }
  });
}

export function captureException(error, context) {
  if (SentryMod) {
    try {
      SentryMod.captureException(error, context);
    } catch (_) {
      /* ignore */
    }
    return;
  }
  if (pending.length < 20) pending.push([error, context]);
  load();
}

export function addBreadcrumb(breadcrumb) {
  if (SentryMod) {
    try {
      SentryMod.addBreadcrumb(breadcrumb);
    } catch (_) {
      /* ignore */
    }
  }
}
